import {all, call, fork, put, takeEvery} from "redux-saga/effects";

import {REGISTER_USER} from "./actionTypes";
import {registerUserError, registerUserSuccess} from "./actions";
import {register} from "../../../helpers/auth";
import {getProfile, userUpdated} from "../user/actions";
import {
    getAgentsAction,
    getBdsAction,
    getClientsAction,
    getCustodiansAction,
    getGroupsAction,
    getRiasAction
} from "../../info/actions";

function* registerUser({payload: {user, history}}) {
    try {
        const response = yield call(register, user);
        yield put(registerUserSuccess());
        yield put(userUpdated(response));
        yield put(getProfile(history));
        yield put(getCustodiansAction());
        yield put(getBdsAction());
        yield put(getRiasAction());
        yield put(getAgentsAction());
        yield put(getClientsAction());
        yield put(getGroupsAction());
        history.push("/profile");
    } catch (error) {
        console.error(error);
        yield put(registerUserError(error));
    }
}

export function* watchUserRegister() {
    yield takeEvery(REGISTER_USER, registerUser);
}

function* registerSaga() {
    yield all([fork(watchUserRegister)]);
}

export default registerSaga;
